// @ts-nocheck
import Footer from 'components/Footer'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useFetchLottery } from 'state/lottery/hooks'
import styled from 'styled-components'
import Banner from './components/Banner'
import GameList from './components/GameList'

const redCircle = require('../../assets/images/home/red-circle.webp').default
const blueCircle = require('../../assets/images/home/blue-circle.webp').default

const HomeWrap = styled.div`
  height: auto;
  min-height: calc(100vh - 60px);
  margin: 0 auto;
  background: #f1f1f1;
  @media (max-width: 768px) {
    padding: 0;
  }
`

const BgWrap = styled.div`
  width: 100%;
  height: 100%;
  background: url(${redCircle}) 0px 930px no-repeat, url(${blueCircle}) right 740px no-repeat;
  @media (max-width: 768px) {
    background: url(${redCircle}) 0px 730px no-repeat, url(${blueCircle}) right 540px no-repeat;
    background-size: 100px auto;
  }
`

const HomePage: React.FunctionComponent = () => {
  useFetchLottery()
  return (
    <>
      <Helmet title="MojitoGames - play and win just in MojitoGames">
        <meta name="description" content="Play and win just in MojitoGame! Win in Defi, Cheers with Mojito!" />
        <meta name="keywords" content="MojitoSwap, Dex, Games, MJT" />
        <meta name="twitter:description" content="Play and win just in MojitoGame! Win in Defi, Cheers with Mojito!" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="MojitoGames - play and win just in MojitoGames" />
      </Helmet>
      <HomeWrap>
        <BgWrap>
          <Banner />
          <GameList />
        </BgWrap>
        <Footer />
      </HomeWrap>
    </>
  )
}

export default HomePage
